import { useManager } from '@/domain/mitarbeiter/shared/hooks/useManager/useManager';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Avatar,
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxItem,
  ComboboxList,
  ComboboxSearch,
  ComboboxTrigger,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ErinnerungAnMultiSelect({
  values,
  handleChange,
  arbeitsbereichId,
  id,
}: {
  values: string[];
  handleChange: (value: string[]) => void;
  arbeitsbereichId?: string | undefined;
  id?: string;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { manager } = useManager(currentStandort.id);

  const managerFiltered = arbeitsbereichId
    ? manager.filter(
        (m) => !m.ausgeblendeteArbeitsbereichIds.includes(arbeitsbereichId),
      )
    : manager;

  const options = managerFiltered.map((m) => ({
    value: m.id,
    label: `${m.vorname} ${m.nachname}`,
    vorname: m.vorname,
    nachname: m.nachname,
    avatar: (
      <Avatar
        type="initials"
        initials={`${m.vorname.charAt(0).toUpperCase() + m.nachname.charAt(0).toUpperCase()}`}
      />
    ),
  }));

  return (
    <Combobox
      multiple
      options={options}
      value={values}
      onValueChange={handleChange}>
      <ComboboxTrigger
        wrap
        aria-describedby={id}
        placeholder={t('combobox.placeholder')}
      />
      <ComboboxContent>
        <ComboboxSearch />
        <ComboboxList>
          {options.map((o) => (
            <ComboboxItem key={o.value} option={o} />
          ))}
          <ComboboxEmpty />
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
